import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { msalInstance } from "@/authConfig";

// Detect iframe (Emergent preview panel)
const isInIframe = window !== window.parent;

// Show loading indicator immediately
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#F8F9FA" }}>
    <div style={{ textAlign: "center" }}>
      <div style={{ width: 40, height: 40, background: "#002FA7", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontWeight: "bold", fontSize: 14, margin: "0 auto 12px", fontFamily: "'Cabinet Grotesk', sans-serif" }}>ER</div>
      <p style={{ fontSize: 13, color: "#6B7280" }}>Loading...</p>
    </div>
  </div>
);

function clearStaleMsalInteraction() {
  // Wipe any "interaction in progress" residue ONLY if we're not currently
  // mid-redirect (presence of #code= / #state= in the URL means MSAL needs
  // those keys to complete the response).
  const inMidRedirect = /[#&](code|state|id_token|error)=/.test(window.location.hash + window.location.search);
  if (inMidRedirect) return;
  try {
    Object.keys(window.localStorage).forEach((k) => {
      if (k.includes("msal.interaction.status") || k.includes("interaction.in.progress")) {
        window.localStorage.removeItem(k);
      }
    });
    Object.keys(window.sessionStorage).forEach((k) => {
      if (k.includes("msal.interaction.status") || k.includes("interaction.in.progress")) {
        window.sessionStorage.removeItem(k);
      }
    });
  } catch {}
}

async function startApp() {
  clearStaleMsalInteraction();
  await msalInstance.initialize();

  // In iframe (Emergent preview), we use popup auth — skip handleRedirectPromise
  // because the silent iframe renew it triggers will reliably time out.
  if (!isInIframe) {
    try {
      // Real production redirect: wait fully (MSAL has its own internal timeouts)
      const response = await msalInstance.handleRedirectPromise();
      if (response?.account) {
        msalInstance.setActiveAccount(response.account);
      } else {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
      }
    } catch (error) {
      console.error("MSAL redirect error:", error);
      clearStaleMsalInteraction();
    }
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

startApp();
